import { Chip, SxProps } from '@mui/material';
import { useTranslation } from 'react-i18next';
import TrustedIcon from '../../assets/icons/trusted_icon.svg?react';

interface TrustedSupplierChipProps {
  sx?: SxProps
}

export default function TrustedSupplierChip({ sx }: TrustedSupplierChipProps): React.JSX.Element {
  const { t } = useTranslation(['contracts']);

  return (
    <Chip
      label={t('contracts:trusted_partner')}
      variant="tag"
      icon={<TrustedIcon />}
      sx={sx}
    />
  );
}
